// Address the player enters at checkout (shipping, or billing when part of the order is paid by card).
// Orders ship to US addresses only, so the country is always 'US'.
export interface CheckoutAddress {
  addressLine1: string;
  city: string;
  stateCode: string;
  postalCode: string;
  country: string;
}
